'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const ActionsChat = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsx(SvgIcon, _extends({
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props, {
        ref: ref,
        children: /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            d: "M3.154 14.492c.27 0 .484-.112.817-.396l1.735-1.484c-.345-.272-.653-.739-.653-1.625V6.648c0-1.903 1.244-3.056 3.263-3.056h4.627l-.006-.153c-.132-1.147-.95-1.939-2.49-1.939H2.509C.949 1.5 0 2.34 0 3.805v6.017c0 1.437.918 2.294 2.427 2.294h.092v1.708c0 .408.232.668.635.668m9.143.008c.396 0 .635-.26.635-.668v-.836h.635c1.515 0 2.433-.863 2.433-2.299v-3.89c0-1.465-.95-2.304-2.515-2.304H8.53c-1.61 0-2.508.833-2.508 2.346v3.848c0 1.46.905 2.3 2.508 2.3h1.488l1.463 1.107c.326.284.54.396.817.396"
        })
    })));

export { ActionsChat, ActionsChat as default };
//# sourceMappingURL=ActionsChat.js.map
